/* @flow */
import Store from 'lib/Store';
import { ActionTypes as ChatActionTypes } from 'chat/constants/ChatConstants';
import ChatMessage, { chatMessageFactory } from 'entities/ChatMessage';
import ChatMessageDelivery from 'entities/ChatMessageDelivery';
import { DeliveryStatus } from 'chat/constants/DeliveryConstants';
import { ActionTypes as GroupActionTypes } from 'groups/constants/GroupConstants';
import GroupMessageDelivery from 'entities/GroupMessageDelivery';
import MessageDeliveries from 'collections/MessageDeliveries';
import { PushEvents } from 'pusher/PusherConstants';

class Marker {
  updatedAt: string;
  readSeq: number;

  constructor(attr) {
    this.readSeq = attr['read_seq'];
    this.updatedAt = attr['updated_at'];
  }
}

class DeliveryStore extends Store {
  getInitialState() {
    return {
      deliveries: new MessageDeliveries(),
      markers: {},
    };
  }

  getDeliveryByMessageId(id) {
    /* We need to clone the deliveries so that containers
     * know to rerender when performing a shallow comparison
     * of the otherwise unchanged backbone collection.
    */
    const delivery = this.state.deliveries.findWhereMessageId(id);
    return delivery && delivery.clone();
  }

  storeDeliveries(deliveries) {
    this.state.deliveries.add(deliveries);
  }

  getMarkerForStream(streamId) {
    return this.state.markers[streamId];
  }

  storeMarkersForSteam(streamId, markers) {
    this.state.markers[streamId] = (
      Object.assign(this.state.markers[streamId] || {}, markers)
    );
  }

  handleDispatch(action: Object): void {
    let delivery;
    let chatMessages;

    switch (action.type) {
      case GroupActionTypes.LIST_GROUP_MESSAGES: {
        const deliveries = action.messages.map(groupMessage => {
          return GroupMessageDelivery.createFromGroupMessage(groupMessage);
        });

        this.storeDeliveries(deliveries);
        this.emitChange();
        break;
      }
      case GroupActionTypes.SEND_GROUP_MESSAGE:
        delivery = GroupMessageDelivery.createFromGroupMessage(action.message);
        this.storeDeliveries([delivery]);
        this.emitChange();
        break;
      case ChatActionTypes.SENT_MESSAGE:
        delivery = ChatMessageDelivery.createFromChatMessage(action.message);
        this.storeDeliveries([delivery]);
        this.emitChange();
        break;
      case ChatActionTypes.SEND_MESSAGE:
        delivery = ChatMessageDelivery.createFromChatMessage(action.message);
        delivery.setReadSummaryState(DeliveryStatus.PENDING_INITIAL_ACK);
        this.storeDeliveries([delivery]);
        this.emitChange();
        break;
      case ChatActionTypes.LOAD_CHAT_MESSAGES: {
        // filter only the ChatMessage, no GapChatMessage ect.
        chatMessages = action.messages.filter(message => {
          return (message instanceof ChatMessage);
        });

        // Create the deliveries from ChatMessages.
        const deliveries = chatMessages.map(chatMessage => {
          return ChatMessageDelivery.createFromChatMessage(chatMessage);
        });

        this.storeDeliveries(deliveries);
        this.emitChange();
        break;
      }
      case PushEvents.CHANGESET_CREATE_CHAT_MESSAGE: {
        const deliveries = action.changes
          .map(change => chatMessageFactory(change.content))
          .map(message => ChatMessageDelivery.createFromChatMessage(message));

        if (deliveries.length > 0) {
          this.storeDeliveries(deliveries);
          this.emitChange();
        }
        break;
      }
      case PushEvents.CHANGESET_UPDATE_DELIVERY_UPDATES: {
        const deliveries = action.changes.map(change => ChatMessageDelivery.fromJSON(change.content));
        this.storeDeliveries(deliveries);
        this.emitChange();
        break;
      }
      case PushEvents.MARKER_UPDATE: {
        const data = action.eventData.data.v2;
        const marker = new Marker(data.markers);
        this.storeMarkersForSteam(data['stream_uuid'], marker);
        this.emitChange();
        break;
      }
      default:
        break;
    }
  }
}

export default new DeliveryStore();



// WEBPACK FOOTER //
// ./src/stores/DeliveryStore.js